var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFirstOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 18.25C6.25 18.6642 6.58579 19 7 19C7.41421 19 7.75 18.6642 7.75 18.25L7.75 5.75C7.75 5.33579 7.41421 5 7 5C6.58579 5 6.25 5.33579 6.25 5.75L6.25 18.25ZM17.2197 18.5303C17.5126 18.8232 17.9874 18.8232 18.2803 18.5303C18.5732 18.2374 18.5732 17.7626 18.2803 17.4697L12.8107 12L18.2803 6.53033C18.5732 6.23744 18.5732 5.76256 18.2803 5.46967C17.9874 5.17678 17.5126 5.17678 17.2197 5.46967L11.2197 11.4697C10.9268 11.7626 10.9268 12.2374 11.2197 12.5303L17.2197 18.5303Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFirstOrange);
export default __webpack_public_path__ + "static/media/ArrowFirstOrange.c8dd221e55274778cad13829c52de811.svg";
export { ForwardRef as ReactComponent };